import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask',
  standalone: true
})
export class MaskPipe implements PipeTransform {
  /**
   * Преобразует строку, заменяя все символы кроме последних четырех на '****'.
   *
   * @param value - исходная строка для маскировки.
   * @returns Маскированная строка.
   */
  transform(value: string): string {
    if (!value) return '';

    const visibleDigits = 4;
    const valueLength = value.length;

    // Если длина строки меньше или равна 4, возвращаем исходную строку
    if (valueLength <= visibleDigits) {
      return value;
    }

    const maskedSection = '••••';
    const visibleSection = value.slice(-visibleDigits);

    return maskedSection + visibleSection;
  }
}
